/**
 * Alert
 */

// Module Dependencies
import 'protons';

// Module template
import './_alert.twig';

export const name = 'alert';

export function disable() {}

export function enable() {}

export default enable;
